import { useGrowthBook } from '@growthbook/growthbook-react';
import { useGrowthBookAttributesSet } from '@web-app/hocs/organization';

/**
 * Hook to check if GrowthBook is fully ready for feature flag evaluation.
 * Useful for parts of the UI that may not behave well if a flag changes
 * during a single session.
 *
 * This hook ensures BOTH:
 * 1. GrowthBook features are loaded (growthbook.ready)
 * 2. All attributes have been set (via GrowthBookAttributesContext in OrganizationProvider)
 *
 * @returns true when both GrowthBook is ready and all attributes (user + organization)
 * have been set
 */
export const useGrowthBookReady = (): boolean => {
  const growthbook = useGrowthBook();
  const attributesSet = useGrowthBookAttributesSet();

  // Both conditions must be true:
  // - growthbook.ready: Features have been fetched from CDN
  // - attributesSet: setAttributes() has been called with both user and organization attributes
  return !!growthbook?.ready && attributesSet;
};
